<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('groups.reasig_group') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRefAgencies">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('groups.entity_name') }}</label>
              <el-form-item prop="groupSelected">
                <base-el-select ref="groupsSelect" class="w-full" :groups="listaGroupsGrouping" 
                  v-model="form.groupSelected" :multiple="multiple" filterable :disabled="isLoadingSelect" 
                  :option-key="getGroupKey" @visible-change="onExpand" @change="onChangeInput" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div v-if="multiple">
        <base-button mode='primary' 
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')"
          @click="$refs.groupsSelect.selectAll()"
          :loading="isLoadingSelect"
          />
        <base-button v-else :text="$t('app.unselect_all')"
          @click="$refs.groupsSelect.unselectAll()"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
      </div>
      <div  class="flex-none flex items-center justify-between space-x-2 px-4 bg-white py-2 mt-auto dark:bg-darkblue-900">
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
import { getGroupsSimple } from '@/services/configurations/groups/getGroupsSimple'

export default
{
  name: 'invoice-link-groups-dialog',
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    idFacturae: {
      type: Number,
      default: null,
    },
    idInvoice: {
      type: Number,
      default: null,
    },
    idCliente: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        groupSelected: []
      },
      groups: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
    this.reloadData()
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value) {
        this.reloadData()
      }
    },
    // idFacturae: function (value, oldValue) {
    //   if (oldValue !== value) {
    //     this.reloadData()
    //   }
    // },
    // idInvoice: function (value, oldValue) {
    //   if (oldValue !== value) {
    //     this.reloadData()
    //   }
    // },
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isEmptyList: function () {
      return this.groups === undefined || this.groups === null || this.groups.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.groups.length === this.form.groupSelected.length) return true
      else return false
    },
    tiposGrupo: function () {
      return this.$store.getters['config/TIPOS_GRUPO']
    },
    listaGroupsGrouping () {
      const groupTypes = this.tiposGrupo.reduce((acc, x) => ({ ...acc, [x.id]: x }), {})
      return this.groups.reduce((a, b) => ({ ...a, [groupTypes[b.idTipo]?.name]: [...(a[groupTypes[b.idTipo]?.name] || []), b] }), {})
    },
  },
  methods: {
    reloadData: async function () {
      this.isLoadedData = false
      const data = await getGroupsSimple({ idFacturae: this.idFacturae, idInvoice: this.idInvoice, idCliente: this.idCliente })
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      } else {
        this.groups = data.Respuesta
      }
      this.isLoadedData = true
    },
    getGroupKey: function (grupo) {
      return grupo.IdGrupo
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.groupSelected = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form.groupSelected)
      this.form.groupSelected = []
    },
  }
}
</script>

<style lang="scss" scoped></style>
